var _path, _path2, _path3, _path4, _path5, _path6, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimezone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0756 2.22864C13.2789 1.48444 11.3019 1.28972 9.39454 1.66911C7.4872 2.0485 5.7352 2.98497 4.36008 4.36008C2.98497 5.73519 2.0485 7.4872 1.66911 9.39453C1.28972 11.3019 1.48444 13.2789 2.22864 15.0755C2.97285 16.8722 4.23312 18.4079 5.85008 19.4883C7.46704 20.5687 9.36807 21.1454 11.3128 21.1454C11.7215 21.1454 12.0529 21.4767 12.0529 21.8855C12.0529 22.2942 11.7215 22.6256 11.3128 22.6256C9.07532 22.6256 6.88811 21.9621 5.02774 20.719C3.16736 19.4759 1.71738 17.7091 0.861138 15.642C0.00490136 13.5748 -0.219129 11.3002 0.217377 9.10576C0.653883 6.9113 1.73132 4.89556 3.31344 3.31344C4.89556 1.73132 6.9113 0.653882 9.10577 0.217377C11.3002 -0.219129 13.5749 0.00490199 15.642 0.861139C17.7091 1.71738 19.4759 3.16736 20.719 5.02774C21.9621 6.88812 22.6256 9.07532 22.6256 11.3128C22.6256 11.7215 22.2942 12.0529 21.8855 12.0529C21.4767 12.0529 21.1454 11.7215 21.1454 11.3128C21.1454 9.36808 20.5687 7.46704 19.4883 5.85008C18.4079 4.23312 16.8722 2.97285 15.0756 2.22864Z",
    fill: "#828FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8282 7.82393L1.79736 7.82393L1.79736 6.34375L20.8282 6.34375L20.8282 7.82393Z",
    fill: "#828FAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4273 16.2819L1.79736 16.2819L1.79736 14.8018L13.4273 14.8018C13.8361 14.8018 14.1674 15.1331 14.1674 15.5418C14.1674 15.9506 13.8361 16.2819 13.4273 16.2819Z",
    fill: "#828FAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2421 22.6253C21.1106 22.6253 22.6253 21.1106 22.6253 19.2421C22.6253 17.3736 21.1106 15.8588 19.2421 15.8588C17.3736 15.8588 15.8588 17.3736 15.8588 19.2421C15.8588 21.1106 17.3736 22.6253 19.2421 22.6253ZM19.2421 23.9998C21.8697 23.9998 23.9998 21.8697 23.9998 19.2421C23.9998 16.6145 21.8697 14.4844 19.2421 14.4844C16.6145 14.4844 14.4844 16.6145 14.4844 19.2421C14.4844 21.8697 16.6145 23.9998 19.2421 23.9998Z",
    fill: "#828FAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0311 17.1279C19.323 17.1279 19.5597 17.3646 19.5597 17.6566V19.2425H21.1456C21.4376 19.2425 21.6742 19.4791 21.6742 19.7711C21.6742 20.0631 21.4376 20.2997 21.1456 20.2997H19.1368C18.7865 20.2997 18.5024 20.0157 18.5024 19.6654V17.6566C18.5024 17.3646 18.7391 17.1279 19.0311 17.1279Z",
    fill: "#828FAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9053 1.09453C5.99088 10.1042 8.87287 18.4773 10.8713 21.475L9.63976 22.296C7.40916 18.9501 4.37044 9.98396 9.60583 0.385742L10.9053 1.09453Z",
    fill: "#828FAB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23216_77",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 8,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2554,
    y: 0.740234,
    width: 7.40088,
    height: 13.7445,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23216_77)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68891 -5.64221C13.9798 0.406471 14.949 9.20841 14.4219 12.7724C14.3621 13.1768 14.6414 13.553 15.0457 13.6128C15.4501 13.6727 15.8263 13.3933 15.8861 12.989C16.4745 9.01101 15.3938 -0.394213 6.56129 -6.83798L5.68891 -5.64221Z",
    fill: "#828FAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/timezone.be2f1ffb.svg";
export { ForwardRef as ReactComponent };